export const productOrBrandSpotlightTemplateHtml = `<!DOCTYPE html>
<html xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" lang="en">
    <head>
        <title></title>
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
        <meta name="viewport" content="width=device-width,initial-scale=1">
        <!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch><o:AllowPNG/></o:OfficeDocumentSettings></xml><![endif]-->
        <style>
            * {
                box-sizing: border-box
            }

            body {
                margin: 0;
                padding: 0
            }

            a[x-apple-data-detectors] {
                color: inherit!important;
                text-decoration: inherit!important
            }

            #MessageViewBody a {
                color: inherit;
                text-decoration: none
            }

            p {
                line-height: inherit
            }

            .desktop_hide,.desktop_hide table {
                mso-hide: all;
                display: none;
                max-height: 0;
                overflow: hidden
            }

            .image_block img+div {
                display: none
            }

            sub,sup {
                font-size: 75%;
                line-height: 0
            }

            @media (max-width: 720px) {
                .image_block div.fullWidth {
                    max-width:100%!important
                }

                .mobile_hide {
                    display: none
                }

                .row-content {
                    width: 100%!important
                }

                .stack .column {
                    width: 100%;
                    display: block
                }

                .mobile_hide {
                    min-height: 0;
                    max-height: 0;
                    max-width: 0;
                    overflow: hidden;
                    font-size: 0
                }

                .desktop_hide,.desktop_hide table {
                    display: table!important;
                    max-height: none!important
                }

                .row-1 .column-1 .block-3.heading_block h1 {
                    font-size: 32px!important
                }

                .row-1 .column-1 .block-2.heading_block h1 {
                    font-size: 12px!important
                }

                .row-1 .column-1 .block-4.paragraph_block td.pad>div {
                    font-size: 14px!important
                }

                .row-1 .column-1 .block-4.paragraph_block td.pad {
                    padding: 0 0 32px!important
                }

                .row-1 .column-1 .block-6.button_block td.pad {
                    padding: 32px 0 0!important
                }

                .row-1 .column-1 .block-6.button_block a,.row-1 .column-1 .block-6.button_block div,.row-1 .column-1 .block-6.button_block span {
                    font-size: 14px!important;
                    line-height: 28px!important
                }

                .row-1 .column-1 {
                    padding: 40px 24px!important
                }

                .row-2 .column-1 {
                    padding: 48px 24px!important
                }
            }
        </style>
        <!--[if mso ]><style>sup, sub { font-size: 100% !important; } sup { mso-text-raise:10% } sub { mso-text-raise:-10% }</style> <![endif]-->
    </head>
    <body class="body" style="background-color:#fff;margin:0;padding:0;-webkit-text-size-adjust:none;text-size-adjust:none">
        <table class="nl-container" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#fff">
            <tbody>
                <tr>
                    <td>
                        <table class="row row-1" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#10304d">
                            <tbody>
                                <tr>
                                    <td>
                                        <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;color:#333;width:700px;margin:0 auto" width="700">
                                            <tbody>
                                                <tr>
                                                    <td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:40px;padding-left:40px;padding-right:40px;padding-top:60px;vertical-align:top;border-top:0;border-right:0;border-bottom:0;border-left:0">
                                                        <table class="image_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0">
                                                            <tr>
                                                                <td class="pad" style="padding-bottom:40px;width:100%;padding-right:0;padding-left:0">
                                                                    <div class="alignment" align="center" style="line-height:10px">
                                                                        <div style="max-width:124px">
                                                                            <img src="https://d15k2d11r6t6rl.cloudfront.net/pub/c524/b1oxpgm8/yub/3ji/j88/Dispo%20Logos.png" style="display:block;height:auto;border:0;width:100%" width="124" alt title height="auto">
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                        <table class="heading_block block-2" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0">
                                                            <tr>
                                                                <td class="pad" style="padding-bottom:16px;text-align:center;width:100%">
                                                                    <h1 style="margin:0;color:#c1d3f1;direction:ltr;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:14px;font-weight:700;letter-spacing:1px;line-height:120%;text-align:center;margin-top:0;margin-bottom:0;mso-line-height-alt:16.8px">
                                                                        <span class="tinyMce-placeholder" style="word-break: break-word;">NEW PRODUCT PROMOTION</span>
                                                                    </h1>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                        <table class="heading_block block-3" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0">
                                                            <tr>
                                                                <td class="pad" style="padding-bottom:16px;text-align:center;width:100%">
                                                                    <h1 style="margin:0;color:#fff;direction:ltr;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:48px;font-weight:700;letter-spacing:normal;line-height:120%;text-align:center;margin-top:0;margin-bottom:0;mso-line-height-alt:57.599999999999994px">
                                                                        <span class="tinyMce-placeholder" style="word-break: break-word;">Get it before it’s gone!</span>
                                                                    </h1>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                        <table class="paragraph_block block-4" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word">
                                                            <tr>
                                                                <td class="pad" style="padding-bottom:48px">
                                                                    <div style="color:#fff;direction:ltr;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;letter-spacing:0;line-height:120%;text-align:center;mso-line-height-alt:19.2px">
                                                                        <p style="margin:0">Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                        <table class="image_block block-5" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0">
                                                            <tr>
                                                                <td class="pad" style="width:100%;padding-right:0;padding-left:0">
                                                                    <div class="alignment" align="center" style="line-height:10px">
                                                                        <div class="fullWidth" style="max-width:620px">
                                                                            <img src="https://d15k2d11r6t6rl.cloudfront.net/pub/c524/b1oxpgm8/k1g/8r1/1pn/Product_Photo.jpg" style="display:block;height:auto;border:0;width:100%" width="620" alt title height="auto">
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                        <table class="button_block block-6" width="100%" border="0" cellpadding="48" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0">
                                                            <tr>
                                                                <td class="pad">
                                                                    <div class="alignment" align="center">
                                                                        <!--[if mso]>
<v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word"   style="height:56px;width:314px;v-text-anchor:middle;" arcsize="8%" fillcolor="#0075e0">
<v:stroke dashstyle="Solid" weight="0px" color="#0075e0"/>
<w:anchorlock/>
<v:textbox inset="0px,0px,0px,0px">
<center dir="false" style="color:#ffffff;font-family:Arial, sans-serif;font-size:16px">
<![endif]-->
                                                                        <div style="background-color:#0075e0;border-bottom:0 solid transparent;border-left:0 solid transparent;border-radius:4px;border-right:0 solid transparent;border-top:0 solid transparent;color:#fff;display:block;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:16px;font-weight:700;mso-border-alt:none;padding-bottom:12px;padding-top:12px;text-align:center;text-decoration:none;width:60%;word-break:keep-all">
                                                                            <span style="word-break: break-word; padding-left: 20px; padding-right: 20px; font-size: 16px; display: inline-block; letter-spacing: normal;">
                                                                                <span style="word-break: break-word; line-height: 32px;">Shop Now</span>
                                                                            </span>
                                                                        </div>
                                                                        <!--[if mso]></center></v:textbox></v:roundrect><![endif]-->
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table class="row row-2" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0">
                            <tbody>
                                <tr>
                                    <td>
                                        <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;border-radius:0;color:#000;width:700px;margin:0 auto" width="700">
                                            <tbody>
                                                <tr>
                                                    <td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:48px;padding-left:48px;padding-right:48px;padding-top:48px;vertical-align:top;border-top:0;border-right:0;border-bottom:0;border-left:0">
                                                        <table class="paragraph_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word">
                                                            <tr>
                                                                <td class="pad" style="padding-bottom:16px">
                                                                    <div style="color:#121516;direction:ltr;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:12px;font-weight:400;letter-spacing:0;line-height:180%;text-align:center;mso-line-height-alt:21.6px">
                                                                        <p style="margin:0">
                                                                            Questions? Please refer to our FAQs or emailus at <u>hello@northcannabisco.com</u>
                                                                            .<br>
                                                                            Copyright © 2024 Dutchie, Inc - All Rights Reserved.<br>2728 North West Potts Court, Bend OR, 97701
                                                                        </p>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
        <!-- End -->
    </body>
</html>`;
